
export const Data = [
  {
    "id": 1,
    "name": "Dictionary Application",
    "description": "English Language dictionary that gives meaning of words,their various antonym and synonyms.",
    "technology": ["react","TailwindCss"],
    "screenShot":"https://i.postimg.cc/FKSwNgWv/screenshot2.png",
    "liveProject":"https://ibrahimdictionary.vercel.app/",
    "github":"https://github.com/hebrohim/dictionaryApplication"
  },
  {
    "id": 2,
    "name": "Elysium Hotel",
    "description": "Elysium Hotel landing page",
    "technology": ["react","TailwindCss"],
    "screenShot":"https://i.postimg.cc/G342fFMV/elysium.png",
    "liveProject":"https://elysium-hotel.vercel.app/",
    "github":"https://github.com/hebrohim/Elysium-Hotel-"
  },
  {
    "id": 3,
    "name": "Country Api",
    "description": "A react application that shows details about ALL countries across the word including their flag,population,currency etc",
    "technology": ["React","TailwindCss"],
    "screenShot":"https://i.postimg.cc/c1vsywht/country-Api.png",
    "liveProject":"https://rest-countries-api-hebrohim.vercel.app",
    "github":"https://i.postimg.cc/QCVPkKqj/country-Api.png"
  },
  {
    "id": 4,
    "name": "Weather App",
    "description": "A JavaScript Weather Application to get weather condition of any city across the world",
    "technology": ["React","Css","media Query"],
    "screenShot":"https://i.postimg.cc/JhxkVPf4/weather-App.png",
    "liveProject":"https://hebrohimweatherapp.netlify.app/",
    "github":"https://github.com/hebrohim/weatherApp"
  },
      {
        "id": 5,
        "name": "accordion",
        "description": "A react based accordion component that allows user to show and hide sections of related content on a page.",
        "technology": ["react","css"],
        "screenShot":"https://i.postimg.cc/5NQyTXtr/accordion.png",
        "liveProject":"https://accordion-sepia.vercel.app/",
        "github":"https://github.com/hebrohim/Accordion"
      },
     
      {
        "id": 6,
        "name": "React Menu page",
        "description": "A react menu page that displays a list of foods on a temporary surface. It appears when the user interacts with a button.",
        "technology": ["react","css grid"],
        "screenShot":"https://i.postimg.cc/MKQMvqLg/react-MEnu-Page.png",
        "liveProject":"https://menu-page-nu.vercel.app",
        "github":"https://github.com/hebrohim/menuPage"
      },
      {
        "id": 7,
        "name": "Scientific Calculator",
        "description": "A JavaScript calculator implementation featuring functions, order of operation, and history with recall for problem and solution.",
        "technology": ["html","css", "javascript"],
        "screenShot":"https://i.postimg.cc/XvrwYDrQ/scientific-Calculator.png",
        "liveProject":"https://ibscientificcalc.netlify.app/",
        "github":"https://github.com/hebrohim/scientificCasioCalculator"
      },
     
    
      {
        "id": 8,
        "name": "Users Dashboard",
        "description": "Provides details of user",
        "technology": ["ReactJs","React Pagination","bootstrap","css"],
        "screenShot":"https://i.postimg.cc/xCQK6qZ0/user.png",
        "liveProject":"https://userbasedashboard.netlify.app/",
        "github":"https://github.com/hebrohim/userBaseDashBoard"
      },
      {
        "id": 9,
        "name": "Vue Counter App",
        "description": "a vue based counter Application with routing and error boundary",
        "technology": ["vue","css"],
        "screenShot":"https://i.postimg.cc/7Z1hQzZN/vue-Counter-App.png",
        "liveProject":"https://my-alt-school-vue-exam.vercel.app",
        "github":"https://github.com/hebrohim/myAltSchoolVueExam"
      },
      {
        "id": 10,
        "name": "review Page",
        "description": "A react page (in form of a slider) thats shows review from different authors",
        "technology": ["React","css"],
        "screenShot":"https://i.postimg.cc/Kj6GzGJf/review-Page.png",
        "liveProject":"https://react-review-page.vercel.app",
        "github":"https://github.com/hebrohim/reactReviewPage"
      },
      {
        "id": 11,
        "name": "Portfolio",
        "description": "my portfolio built with react",
        "technology": ["React","css"],
        "screenShot":"https://i.postimg.cc/brpgcTyN/port-Screen.png",
        "liveProject":"https://raheemibrahim.vercel.app/",
        "github":"https://github.com/hebrohim/portfolio_raheemIbrahim"
      },
       {
        "id": 12,
        "name": "Todo Application",
        "description": "A web based app that allow users manage tasks and activities. Users can create, edit, organize, and prioritize a list of tasks they need to complete.",
        "technology": ["React","typescript","vite","TailwindCss","localStorage"],
        "screenShot":"https://i.postimg.cc/VkLNjstd/screenshot.png",
        "liveProject":"https://ibrahimtodo.vercel.app/",
        "github":"https://github.com/hebrohim/todoList"
      }
      
      
     
     
    
]

